// extracted by mini-css-extract-plugin
module.exports = {"migrateTip":"_3VG_E","tip":"_30KSB","close":"_481rL"};